import * as React from 'react';

import type { W_Equipment_FindForPurchaseOrderOptions_VM } from 'ab-api/web/equipment/findForPurchaseOrderOptions';

import ColorSquare from 'af-components/ColorSquare';

import styles from './styles.module.scss';

type Props = W_Equipment_FindForPurchaseOrderOptions_VM;

const ToolLabel = (option: Props) => {

	const specification = option.specification ? `(${option.specification})`.replace('((', '(').replace('))', ')') : '';

	return (
		<div className={styles['equipment-option']}>
			<ColorSquare color={option.equipmentCostCategoryColor} />
			<span>{option.code} {specification}</span>
		</div>
	);
};

export default ToolLabel;
